import { mergeClass } from "../../../resources/utils/helper";
import { useState } from "react";
import classes from "./input.module.css";
import { IoIosEye, IoMdEyeOff } from "react-icons/io";

export const Input = ({
  rightIcon,
  type,
  label,
  label2, // sub label
  value, // input value
  setValue, //setValue
  noBorder,
  placeholder,
  disabled,
  setter,
  customStyle, //Input Container inline Style
  inputStyle, //Input inline Style
  labelStyle, //Label inline Style
  error, // Show Error Boolean
  errorText, // Error Text
  leftIcon, // Icon For Input
  // toottipIcon, // Tool Tip Icon
  // tooltipText, // Tool Tip Text
  // tooltipClassName, // Tool Tip class
  inputRef,
  labelClass,
  onEnterClick,
  inputContainer,
  innerClass,
  inputClass,
  rightIconGreenVariant = false,
  prefix = "",
  rightIconClass,
  ...props
}) => {
  const [passToggle, setPassToggle] = useState(false);

  return (
    <>
      <div
        className={`${[
          classes.inputContainer,
          inputContainer && inputContainer,
        ].join(" ")}`}
      >
        {label && (
          <label
            htmlFor={`input${label}`}
            className={`fs-16 fw-700 ${[classes.labelText, labelClass].join(
              " "
            )}`}
            style={{ ...labelStyle }}
          >
            {label} <span className="label2">{label2 && label2}</span>
          </label>
        )}
        <div
          className={`${[classes.inputPassContainer, innerClass].join(" ")}`}
          style={{ ...customStyle }}
        >
          {leftIcon && <div className={classes.leftIconBox}>{leftIcon}</div>}

          <input
            value={value}
            onChange={(e) => {
              setValue && setValue(e.target.value);
              setter && setter(e.target.value);
            }}
            min={props.min !== undefined ? props.min : type === "number" ? "0" : undefined}
            disabled={disabled}
            placeholder={placeholder}
            type={passToggle === true ? "text" : type}
            id={`input${label}`}
            className={`fs-14 fw-400 ${[
              noBorder && classes.noBorder,
              classes.inputBox,
              rightIconGreenVariant && classes.greenInputBorder,
              inputClass,
            ].join(" ")}`}
            style={{ ...inputStyle }}
            onKeyPress={(e) =>
              ["Enter", "NumpadEnter"].includes(e.code) &&
              onEnterClick &&
              onEnterClick()
            }
            onBlur={(e) => {
              if (type === "text" && typeof value === "string") {
                setValue && setValue(value?.trim());
              }
              if (props.onBlur) {
                props.onBlur(e);
              }
            }}
            ref={inputRef}
            {...props}
          />
          {rightIcon && (
            <div
              className={mergeClass(
                rightIconGreenVariant && classes.rightIconGreen,
                classes.rightIconBox,
                rightIconClass
              )}
            >
              {rightIcon}
            </div>
          )}

          {type === "password" && passToggle === false && (
            // <VisibilityOffIcon
            <IoMdEyeOff
              className={classes.passwordIcon}
              onClick={(e) => setPassToggle(!passToggle)}
            />
          )}
          {type === "password" && passToggle && (
            // <VisibilityIcon
            <IoIosEye
              className={classes.passwordIcon}
              onClick={(e) => setPassToggle(!passToggle)}
            />
          )}
        </div>
        {errorText && (
          <p className={`mt-2 text-danger ${[classes.errorText].join(" ")}`}>
            {errorText}
          </p>
        )}
      </div>
    </>
  );
};



